import { render } from "./UErrorContainer.vue?vue&type=template&id=23015224"
const script = {}
script.render = render

export default script